import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_SFTP_USERS_ANALYTICS, GET_SFTP_USERS_ANALYTICS_ERROR, GET_SFTP_USERS_ANALYTICS_SUCCESS } from '../../actions.js';

function* getSFTPUsersAnalytics({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/v1/user-analytics/sftp`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_SFTP_USERS_ANALYTICS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SFTP_USERS_ANALYTICS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SFTP_USERS_ANALYTICS_ERROR, payload: error });
  }
}

export function* watchGetSFTPUsersAnalytics() {
  yield takeEvery(GET_SFTP_USERS_ANALYTICS, getSFTPUsersAnalytics);
}

function* getSFTPUsersAnalyticsSaga() {
  yield all([fork(watchGetSFTPUsersAnalytics)]);
}

export default getSFTPUsersAnalyticsSaga;
